import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { doSearch, clearSearchResults } from '../../fundialSlice'
import SongItem from '../SongItem/SongItem'
import SongItemWrapper from '../SongItemWrapper/SongItemWrapper'
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';


const Search = (props) => {
    const [inputText, setInputText] = useState('');
    const [limit, setLimit] = useState(20);
    const [searchCounter, setSearchCounter] = useState(0);

    useEffect(() => {
        if (inputText.length >= 3) {
            doSearch({ value: inputText });
        }

        if (searchCounter > 0 && inputText.length == 0) {
            setSearchCounter(0);
            clearSearch();
        }

    }, [inputText]);


    const doSearch = (value) => {
        setSearchCounter(searchCounter + 1);
        props.doSearch(inputText);

    };


    function clearSearch() {
        props.clearSearchResults();
        setInputText('');
    }

    function changeHandler(e) {
        setInputText(e.value);
    }

    return (
        <div className="fundial-search">
            <div className="fundial-search-box">

                <h2>חפש שיר</h2>

                <div className="input-search-wrapper">
                    <div className="inner-addon left-addon">
                        <i onClick={(e) => clearSearch()} className={inputText.length > 0 ? 'glyphicon-close-x' : 'glyphicon'}></i>
                        <input
                            onChange={(e) => changeHandler(e.target)}
                            name='search'
                            type='search'
                            placeholder='על פי שם שיר או אמן'
                            aria-label="Search through site content"
                            autoComplete="off"
                            value={inputText}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>

            {inputText.length >= 3 && props.searchResults ? (

                <div className="fundial-header-search-result">
                    <span className="resultsTitle">מציג {props.searchResults.length.toString()} תוצאות עבור המילה '{inputText}'</span>

                    {props.searchResults.slice(0, limit).map((item, i) => (
                        <div>
                            <SongItemWrapper audio={item} isDownloadMode={true} isPlaylistMode={false} songId={item.productId}  >
                                <SongItem isDisplayPlayer={true} playerSize={87} isDetailsFromLeft={true} audio={item} onClickSong={()=> {}} ></SongItem>
                            </SongItemWrapper>
                            <div className="sparator"></div>
                        </div>
                    ))}

                </div>
            ) : null}

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        searchResults: state.fundialPage.search.searchResults
    }

}

const mapDispatchToProps = {
    doSearch,
    clearSearchResults,
    showAppLoader,
    hideAppLoader,
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)
